import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ActionService } from 'src/app/shared/services/action/action.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import { ActionTatOverallComponent } from './components/action-tat-overall/action-tat-overall.component';
import { ActionTatHierarchyComponent } from './components/action-tat-hierarchy/action-tat-hierarchy.component';
import { ActionTatHistogramComponent } from './components/action-tat-histogram/action-tat-histogram.component';
import { ActionTatCategoryChartsComponent } from './components/action-tat-category-charts/action-tat-category-charts.component';


@Component({
    selector: 'app-project-action-tat-home',
    templateUrl: './project-action-tat-home.component.html',
    styleUrls: ['./project-action-tat-home.component.scss'],
    imports: [ActionTatOverallComponent, ActionTatHierarchyComponent, ActionTatHistogramComponent, ActionTatCategoryChartsComponent]
})
export class ProjectActionTatHomeComponent implements OnInit {
  mainDiscription: string = 'Review closed actionable issues, understand the proportion resolved within and outside the target TAT, and see counts by hierarchy.'
  destroyRef = inject(DestroyRef);
  loadingOverallData: boolean = false;
  dateFilterField = _.get(Helpers, 'datePicker.dateFilterType', 1) == 1 ? "feedback_request_date" : "created_date";
  totalResponses: string | null = null;
  totalActionableResponses: string | null = null;
  data: any = []
  projectId: string = '';
  queryAndData: any = {};
  universalFilter: any = {};
  groupAliasKey: any = '';
  raterDetails: any = {}
  brandDetails: any = {}
  overallData: any = {
    elementId: "action-hierarchy-" + this.getTimeStamp(),
    data: []
  }
  distType: string = "percentage";
  categoryChartId: string = "ltms-category-" + this.getTimeStamp();
  histogramChartId: string = "ltms-histogram-" + this.getTimeStamp()
  filters: any = {};
  selectedHierarchy: any = {};
  startDate: any = '';
  endDate: any = ''

  constructor(public _actionService: ActionService, private _helpers: HelpersService, private route: ActivatedRoute) {

  }
  ngOnInit() {
    this._helpers.appState.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((state: any) => {
      if (state && !state.pending) {
        this.startDate = state.datePicker.startDate;
        this.endDate = state.datePicker.endDate;
        this.universalFilter = state.universalFilter ? state.universalFilter : {};
        this.projectId = state.brandDetails._id;
        this.brandDetails = state.brandDetails;
        this.selectedHierarchy = state.hierarchyStack;
        let field_id: string = '';
        if (this.selectedHierarchy && this.selectedHierarchy.length) {
          field_id = this.selectedHierarchy[this.selectedHierarchy.length -1].field_id;
        }
        this.groupAliasKey = this._actionService.getGroupAliasKey(field_id, state.brandDetails.hierarchy_list_alias)
        this.getOverallData()
      }
    })
  }
  onDrilldownChange(filters?: any) {
    this.filters = filters
    this.categoryChartId = "ltms-category-" + this.getTimeStamp();
    this.histogramChartId = "ltms-histogram-" + this.getTimeStamp()
  }

  getTimeStamp() {
    return new Date().getTime()
  }

  getRequestParams() {
    this.loadingOverallData = true;
    this.data = [];
    var params = this._actionService.getInitialQueryParameters();
    if (this.selectedHierarchy && this.selectedHierarchy.length) {
      params.hierarchy_stack = this.selectedHierarchy;
    }
    params.from = this.startDate
    params.group_key_alias = this.groupAliasKey
    params.to = this.endDate
    params.view_type = 'overall';
    params.field_id = 'overall';
    params.field_type = 'overall';
    params.question_aggs = true;
    params.universal_filter = this.universalFilter;
    params.is_custom_date_range_selected = Helpers.isCustomDateRangeSelected;
    params.actionable_filter = _.get(this.brandDetails, "action_management_configuration.actionables", {});
    params.action_type = "tat";
    params.age_type = _.get(this.brandDetails, "action_management_configuration.ageing_config.type", 1);
    params.date_field = this.dateFilterField || "created_date";
    params.turnaround = _.get(this.brandDetails, "action_management_configuration.ageing_config.turnaround_time", 0);
    params.brand_id = this.projectId;
    this.queryAndData = {};
    this.queryAndData.query = params;
    return params;
  }
  validateApiResponse(response: any) {
    return (response.code == 0 && _.hasIn(response, 'data.feed_details.current') && !_.isEmpty(response.data.feed_details.current))
  }
  getOverallData() {
    this.totalResponses = null;
    this.totalActionableResponses = null;
    const params = this.getRequestParams();
    this._actionService.getComparisonData(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((responseObject) => {
      if (this.validateApiResponse(responseObject)) {
        let feed_details = {}
        let tat_details = {}
        feed_details = _.get(responseObject, 'data.feed_details', {})
        tat_details = _.get(responseObject, 'data.tat', {})
        if (tat_details && !_.isEmpty(tat_details)) {
          feed_details["tat"] = _.get(tat_details, "tat", 0);
          feed_details['within_tat'] = _.get(tat_details, "within_tat", 0);
          feed_details['outside_tat'] = _.get(tat_details, "outside_tat", 0);
        }
        let doc_count = _.get(feed_details, 'current.doc_count', 0);
        let actionables = _.get(feed_details, 'current.actionables', 0);
        this.totalResponses = new Number(doc_count).toLocaleString('en-IN')
        this.totalActionableResponses = new Number(actionables).toLocaleString('en-IN')
        var response = this.processOverallReponse(Helpers.deepClone(feed_details));
        // response = _.assign(response, tat_details);
        response.actionables = _.get(feed_details, 'current.actionables', 0);
        response.tat = Math.round(response.tat)
        if (this.selectedHierarchy && this.selectedHierarchy.length) {
          response.name = this.selectedHierarchy[0].group_key[0];
        } else {
          response.name = _.get(this.brandDetails, 'name', '');
        }

        response.resolved = _.get(response, 'resolved', 0);
        response.unresolved = _.get(response, 'unresolved', 0);
        this.overallData.data = [response];
        this.overallData.query = params;
        this.overallData.elementId = "action-hierarchy-" + new Date().getTime(),
          this.loadingOverallData = false;

      } else {
        this.loadingOverallData = false;
        this.totalResponses = '0';
        this.totalActionableResponses = '0';
      }
    }, () => {
      // Handle error case
      this.totalResponses = '0';
      this.totalActionableResponses = '0';
    })
  }

  processOverallReponse(response: any) {
    var distributions = [];
    if (this.raterDetails && this.raterDetails.distributions) {
      distributions = this.raterDetails.distributions;
    }
    if (response.tat >= 0) {
      var currentData = response.current;
      var previousData = {};
      var processedResponse: any = {};
      processedResponse = response;
      processedResponse.age = Math.round(_.get(response, "age", 0));
      var resolvedUnresolvedData = this.getDistribution(processedResponse, 100, currentData.status_distribution);

      var ageDistribution = this.getAgeDistribution(response.within_tat, response.outside_tat, 100);

      processedResponse.tat = Math.round(_.get(response, "tat", 0));

      var tatDistribution = this.getAgeDistribution(response.within_tat, response.outside_tat, 100);

      processedResponse.tat_distribution = tatDistribution.distribution;
      processedResponse.age_distribution = ageDistribution.distribution;
      processedResponse.status_distribution = resolvedUnresolvedData.distribution;
      processedResponse.resolved = resolvedUnresolvedData.resolved;
      processedResponse.unresolved = resolvedUnresolvedData.unresolved;

      processedResponse.doc_count = processedResponse.within_tat + processedResponse.outside_tat;
      processedResponse.tat = Math.round(processedResponse.tat);
      processedResponse.percent = {
        doc_count: this.getPercentage(processedResponse.doc_count, processedResponse.doc_count),
        within_tat: this.getPercentage(processedResponse.within_tat, processedResponse.doc_count),
        outside_tat: this.getPercentage(processedResponse.outside_tat, processedResponse.doc_count)
      }
      processedResponse.within_tat_with_percentage = processedResponse.within_tat + '(' + processedResponse.percent.within_tat + '%)'
      processedResponse.outside_tat_with_percentage = processedResponse.outside_tat + '(' + processedResponse.percent.outside_tat + '%)'
      return processedResponse;

    } else {
      return {};
    }
    return response;
  }
  getPercentage(count: number, total: number) {
    let percentage: any = '';
    percentage = (((count / total) * 100)).toFixed(1);
    if (percentage >= 0) {
      return percentage;
    } else {
      return '0.0'
    }
  }

  getAgeDistribution(withInTat: any, outSideTat: any, maxValue: any) {
    var distribution = {
      "value": [],
      "raterType": "distribution",
      "options": {
        "no_of_distribution": 1,
        "distributionType": this.distType,
        "maxValue": maxValue,
        "displayValue": false,
        "totalResponse": withInTat + outSideTat ? withInTat + outSideTat : null,
        "showPercentage": true,
        // "isLinearGradientEnabled":true
      }
    }

    var statusdDistribution: any = [];
    var selectedTab = 'tat'
    var distributionLabels = _.get(Helpers.brandDetail, "action_management_configuration.widget_settings.action_summary", {});
    distributionLabels = {
      green_bucket: _.get(distributionLabels, selectedTab + ".green_bucket", {}),
      red_bucket: _.get(distributionLabels, selectedTab + ".red_bucket", {})
    }
    if (selectedTab == "ageing") {
      statusdDistribution.push({
        'label': distributionLabels.green_bucket.label || 'Unsolved Within Target TAT',
        'rated': withInTat,
        'color': distributionLabels.green_bucket.color || '#10a754',
        'value': distributionLabels.green_bucket.label || 'Unsolved Within Target TAT'
      });
      statusdDistribution.push({
        'label': distributionLabels.red_bucket.label || 'Unsolved Outside Of Target TAT',
        'rated': outSideTat,
        'color': distributionLabels.red_bucket.color || '#69a8fc',
        'value': distributionLabels.red_bucket.label || 'Unsolved Outside Of Target TAT'
      })
    } else if (selectedTab == "tat") {
      statusdDistribution.push({
        'label': distributionLabels.green_bucket.label || 'Solved Within Target TAT',
        'rated': withInTat,
        'color': distributionLabels.green_bucket.color || '#10a754',
        'value': distributionLabels.green_bucket.label || 'Solved Within Target TAT'
      });
      statusdDistribution.push({
        'label': distributionLabels.red_bucket.label || 'Solved Outside Of Target TAT',
        'rated': outSideTat,
        'color': distributionLabels.red_bucket.color || '#fab416',
        'value': distributionLabels.red_bucket.label || 'Solved Outside Of Target TAT'
      })
    }

    distribution.value = statusdDistribution
    return { "distribution": distribution };
  }
  getDistribution(summary: any, maxValue: any, distributions: any) {
    var resolved: number = 0;
    var unresolved: number = 0;
    distributions = JSON.parse(JSON.stringify(distributions));
    var distribution = {
      "value": [],
      "raterType": "distribution",
      "options": {
        "no_of_distribution": 1,
        "distributionType": this.distType,
        "maxValue": maxValue,
        "displayValue": false,
        "totalResponse": (summary && summary.actionables) ? summary.actionables : null,
        "showPercentage": true,
        // "isLinearGradientEnabled":true
      }
    }
    if (distributions) {
      var distributionLabels = _.get(Helpers.brandDetail, "action_management_configuration.widget_settings.action_summary.count", {})
      distributionLabels = {
        "green_bucket": _.get(distributionLabels, "red_bucket", {}),
        "red_bucket": _.get(distributionLabels, "green_bucket", {})
      }
      var statusdDistribution: any = [];

      var closedStatusList = this.getClosedStatusValueFromBrand(this.brandDetails)
      _.each(distributions, function (value: any, key: string) {
        if (closedStatusList.indexOf(key) >= 0) {
          resolved = resolved + value;
        } else {
          unresolved = unresolved + value;
        }
      });
      //changing labels to solved unsolved as enhancement in stats v2
      statusdDistribution.push({ 'label': distributionLabels.red_bucket.label || 'Unsolved', 'rated': unresolved, 'color': distributionLabels.red_bucket.color || '#ed2424', 'value': distributionLabels.red_bucket.label || 'Unresolved' });
      statusdDistribution.push({ 'label': distributionLabels.green_bucket.label || 'Solved', 'rated': resolved, 'color': distributionLabels.green_bucket.color || '#10a754', 'value': distributionLabels.green_bucket.label || 'Resolved' })

      distribution.value = statusdDistribution
    }
    return { "distribution": distribution, "resolved": resolved, "unresolved": unresolved };
  }
  getClosedStatusValueFromBrand(brand_details: any) {
    //get value of closed status from brand
    var status_closed_uuid = "c71a8524-7fc4-49d3-894a-2555dcc6ed07";
    if (_.get(brand_details, 'lw_status_list_map.LW_CLOSED')) {
      status_closed_uuid = brand_details.lw_status_list_map.LW_CLOSED
    } else {
      var maped_status = {}
      if (_.get(brand_details, "status_list")) {
        var status_list = brand_details.status_list
        for (var index in status_list) {
          maped_status[status_list[index].name] = status_list[index]
        }
      }
      if (_.get(maped_status, "Closed.uuid")) {
        status_closed_uuid = maped_status['Closed']['uuid']
      }
    }
    return status_closed_uuid;
  }

}
